import PropTypes from 'prop-types';
import clsx from 'clsx';
import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import { getSiteHeaderVariant, getTravelAgency } from '../../../../store/slices/user';
import SelectCurrency from '../../../SelectCurrency';
import NavbarHelpDropdown from '../NavbarHelpDropdown';
import HeaderVariant from '../../../../constants/HeaderVariant';
import CustomHeaderLinks from '../CustomHeaderLinks';
import LoginButton from '../LoginButton';
import MarkdownToHtml from '../../../MarkdownToHtml';

const NavbarMenu = ({ navbar }) => {
  const { isLoading } = useAuth0();
  const travelAgency = useSelector(getTravelAgency);
  const headerVariant = useSelector(getSiteHeaderVariant);
  const { track } = useAnalytics();
  const doShowWithBranding = !isLoading && headerVariant === HeaderVariant.withBranding;
  const doShowCurrencySelectAfterHelp = travelAgency && travelAgency.siteTheme
    && travelAgency.siteTheme.showCurrencySelectAfterHelp;
  const doMoveHeaderLinksToFooter = travelAgency && travelAgency.siteTheme
    && travelAgency.siteTheme.doMoveHeaderLinksToFooter;
  const doAlignCurrencyFilterWithOtherFilters = !!(travelAgency && travelAgency.filterSettings
    && travelAgency.filterSettings.doAlignCurrencyFilterWithOtherFilters);
  const navbarCenterAffiliateText = travelAgency && travelAgency.settings
    && travelAgency.settings.navbarCenterAffiliateText;

  const handleBackToMainClick = () => {
    track('redirectToMainSite');
    window.location.href = travelAgency.agencyUrl;
  };

  const showLoginButtonPlaceholder = (!doMoveHeaderLinksToFooter && navbar)
    || (doMoveHeaderLinksToFooter && !navbar);

  return showLoginButtonPlaceholder || doShowWithBranding ? (
    <div className={clsx('flex flex-wrap sm:flex-no-wrap flex-row-reverse justify-center items-center gap-4', { 'gap-4': doMoveHeaderLinksToFooter })}>
      {showLoginButtonPlaceholder && <LoginButton />}
      {doShowWithBranding && (
        <>
          {((!doMoveHeaderLinksToFooter && navbar)
            || (doMoveHeaderLinksToFooter && !navbar)) && travelAgency.agencyUrl
            && (
              <a className="inline-block align-middle text-sm md:text-lg self-center" tabIndex="-1" role="button" onKeyDown={handleBackToMainClick} onClick={handleBackToMainClick}>
                <span>{(travelAgency.siteTheme || {}).backToMainSiteLabel || 'BACK TO MAIN SITE'}</span>
              </a>
            )}
          {navbar && <CustomHeaderLinks travelAgencySettings={travelAgency?.settings} />}
          {navbar && (
            <div className={clsx('flex gap-4 sm:gap-4', { 'flex-row': doShowCurrencySelectAfterHelp, 'flex-row-reverse': !doShowCurrencySelectAfterHelp })}>
              <NavbarHelpDropdown doShowWithBranding />
              {!doAlignCurrencyFilterWithOtherFilters && <SelectCurrency />}
            </div>
          )}
        </>
      )}
      {navbar && navbarCenterAffiliateText && (
        <div className="mx-2 text-center flex-grow min-w-0 max-w-[300px]">
          <MarkdownToHtml content={navbarCenterAffiliateText} />
        </div>
      )}
    </div>
  ) : <></>;
};

NavbarMenu.propTypes = {
  navbar: PropTypes.bool,
};

NavbarMenu.defaultProps = {
  navbar: true,
};

export default NavbarMenu;
